import { render, staticRenderFns } from "./ModalViewSettlementPayment.vue?vue&type=template&id=1aa2d7f8&"
import script from "./ModalViewSettlementPayment.vue?vue&type=script&lang=js&"
export * from "./ModalViewSettlementPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports